import { render, staticRenderFns } from "./TranslatedFieldValue.vue?vue&type=template&id=2910b3c0"
import script from "./TranslatedFieldValue.vue?vue&type=script&lang=js"
export * from "./TranslatedFieldValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports